export const ScoringPoints ={
  "Football": {
    "Offensive Players": {
      "Passing Yards_per_yard": 0.04,
      "Passing Touchdowns": 4,
      "Passing Interceptions": -1,
      "Rushing Yards_per_yard": 0.1,
      "Rushing Touchdowns": 6,
      "Receptions": 0.5,
      "Receiving Yards_per_yard": 0.1,
      "Receiving Touchdowns": 6,
      "Two-Point Conversions": 2,
      "Fumbles Lost": -2,
      "Fumble Recovered for a Touchdown": 6
    },
    "Team Defense / Special Teams": {
      "Sacks": 1,
      "Interceptions": 2,
      "Fumbles Recovered": 2,
      "Safeties": 2,
      "Defensive Touchdowns": 6,
      "Kick and Punt Return Touchdowns": 6,
      "Two-Point Conversion Returns": 2,
      "Points Allowed": [
        { "range": "0", "points": 10 },
        { "range": "1-6", "points": 7 },
        { "range": "7-13", "points": 4 },
        { "range": "14-20", "points": 1 },
        { "range": "21-27", "points": 0 },
        { "range": "28-34", "points": -1 },
        { "range": "35+", "points": -4 }
      ]
    },
    "Kicking": {
      "PAT Made": 1,
      "FG Made (0-49 yards)": 3,
      "FG Made (50+ yards)": 5
    }
  },
  "Basketball": {
    "All Players": {
      "Points": 1,
      "Rebounds": 1.2,
      "Assists": 1.5,
      "Blocked Shots": 3,
      "Steals": 3,
      "Turnovers": -1
    }
  },
  "Baseball": {
    "Hitting": {
      "Singles": 2.6,
      "Doubles": 5.2,
      "Triples": 7.8,
      "Home Runs": 10.4,
      "Runs": 1.9,
      "Runs Batted In": 1.9,
      "Base on Balls": 2.6,
      "Hit By Pitch": 2.6,
      "Stolen Bases": 4.2
    },
    "Pitching": {
      "Wins": 4,
      "Strikeouts": 2,
      "Outs": 1,
      "Bases on Balls": -0.9,
      "Hits": -0.9,
      "Hits by Pitch": -0.9,
      "Earned Runs": -2
    }
  },
  "Hockey": {
    "Skaters": {
      "Goals": 6,
      "Assists": 4,
      "Shots On Goal": 0.9,
      "Plus/Minus": 2,
      "Blocks": 1,
      "Power Play": 2
    },
    "Goaltenders": {
      "Wins": 5,
      "Goals Against": -3,
      "Saves": 0.6,
      "Shutouts": 5
    }
  },
  "Soccer": {
    "All Players": {
      "Goals": 10,
      "Assists": 6,
      "Shots": 1,
      "Shots On Goal": 1,
      "Crosses": 0.75,
      "Fouled": 1,
      "Fouls": -0.5,
      "Tackles Won": 1,
      "Interceptions": 0.5,
      "Yellow Cards": -1.5,
      "Red Cards": -3,
      "Penalty Kick Misses": -5
    },
    "Defenders": {
      "Clean Sheets": 3
    },
    "Goalkeepers": {
      "Saves": 2,
      "Goals Against": -2,
      "Wins": 5,
      "Clean Sheets": 5,
      "Penalty Kick Saves": 3
    }
  },
  "Golf": {
    "Per Hole Scoring": {
      "Double Eagle": 20,
      "Eagle": 8,
      "Birdie": 3,
      "Par": 0.5,
      "Bogey": -0.5,
      "Double Bogey": -1,
      "Worse than Double Bogey": -1
    },
    "Tournament Finish Scoring": {
      "1st": 30,
      "2nd": 20,
      "3rd": 18,
      "4th": 16,
      "5th": 14,
      "6th": 12,
      "7th": 10,
      "8th": 9,
      "9th": 8,
      "10th": 7,
      "11th-15th": 6,
      "16th-20th": 5,
      "21st-25th": 4,
      "26th-30th": 3,
      "31st-40th": 2,
      "41st-50th": 1
    },
    "Streaks and Bonuses": {
      "Streak of 3 Birdies or Better (Max 1 Per Round)": 3,
      "Bogey Free Round": 3,
      "All 4 Rounds Under 70 Strokes": 5,
      "Hole in One": 10
    }
  },
  "NASCAR": {
    "Race Scoring": {
      "Place Differential_per_place": 1,
      "Laps Led_per_lap": 0.25
    },
    "Final Position Scoring": {
      "1st": 46,
      "2nd": 42,
      "3rd": 41,
      "4th": 40,
      "5th": 39,
      "6th": 38,
      "7th": 37,
      "8th": 36,
      "9th": 35,
      "10th": 34,
      "11th": 33,
      "12th": 32,
      "13th": 31,
      "14th": 30,
      "15th": 29,
      "16th": 28,
      "17th": 27,
      "18th": 26,
      "19th": 25,
      "20th": 24,
      "21st": 23,
      "22nd": 22,
      "23rd": 21,
      "24th": 20,
      "25th": 19,
      "26th": 18,
      "27th": 17,
      "28th": 16,
      "29th": 15,
      "30th": 14,
      "31st": 13,
      "32nd": 12,
      "33rd": 11,
      "34th": 10,
      "35th": 9,
      "36th": 8,
      "37th": 7,
      "38th": 6,
      "39th": 5,
      "40th": 4,
      "41st": 3,
      "42nd": 2,
      "43rd": 1
    }
  },
  "Formula 1": {
    "Race Scoring": {
      "Race Fastest Lap": 1
    },
    "Final Position Scoring": {
      "1st": 25,
      "2nd": 18,
      "3rd": 15,
      "4th": 12,
      "5th": 10,
      "6th": 6,
      "8th": 4,
      "9th": 2,
      "10th": 1,
      "11th+": 0
    }
  },
  "Boxing": {
    "Boxing Scoring": {
      "Punch Landed": 0.5,
      "Knockdown on Opponent": 12,
      "Being Knocked Down by Opponent": -12,
      "Win Within Rounds 1-2": 100,
      "Win Within Rounds 3-6": 75,
      "Win Within Rounds 7-10": 50,
      "Win Within Rounds 11-12": 25,
      "Decision Win": 20
    }
  },
  "MMA": {
    "MMA Scoring": {
      "Significant Strikes": 0.6,
      "Takedown": 6,
      "Takedown Defense": 3,
      "Submission Attempt": 5,
      "Knockdown": 12,
      "1st Round Win": 100,
      "2nd Round Win": 75,
      "3rd Round Win": 50,
      "4th Round Win": 35,
      "5th Round Win": 25,
      "Decision Win": 20
    }
  },
  "Tennis": {
    "Tennis Scoring": {
      "Match Played": 10,
      "Game Win": 1,
      "Game Loss": -1,
      "Set Won": 3,
      "Set Loss": -3,
      "Ace": 0.5,
      "Double Fault": -0.5
    }
  },
  "Cricket": {
    "Batting": {
      "Run": 1,
      "Boundary Bonus": 1,
      "Six Bonus": 2,
      "30 Run Bonus": 4,
      "Half-Century Bonus": 8,
      "Century Bonus": 16
    },
    "Bowling": {
      "Wicket (Excluding Run Out)": 25,
      "Bonus (LBW/Bowled)": 8,
      "3 Wicket Bonus": 4,
      "4 Wicket Bonus": 8,
      "5 Wicket Bonus": 16,
      "Maiden Over": 12
    },
    "Fielding": {
      "Catch": 8,
      "3 Catch Bonus": 4,
      "Stumping": 12,
      "Run out (Direct hit)": 12,
      "Run out (Not a direct hit)": 6
    }
  }
}